import { useTranslation } from 'react-i18next'

type ChannelView = 'all' | 'single'

interface ChannelViewSwitchProps {
  view: ChannelView
  onChange: (v: ChannelView) => void
}

/**
 * Segmented control toggling between the all-channels and single-channel
 * media views.
 */
export function ChannelViewSwitch({ view, onChange }: ChannelViewSwitchProps) {
  const { t } = useTranslation()
  const options: { value: ChannelView; label: string }[] = [
    { value: 'all', label: t('addToProduct.media.viewAll') },
    { value: 'single', label: t('addToProduct.media.viewSingle') },
  ]
  return (
    <div
      role="group"
      className="inline-flex rounded-lg border border-neutral-200 dark:border-neutral-800 overflow-hidden"
    >
      {options.map((o) => {
        const active = view === o.value
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(o.value)}
            className={[
              'px-3 py-1.5 text-xs font-medium transition-colors',
              active
                ? 'bg-orange-500 text-white'
                : 'bg-white dark:bg-neutral-900 text-neutral-600 dark:text-neutral-400 hover:bg-neutral-50 dark:hover:bg-neutral-800',
            ].join(' ')}
          >
            {o.label}
          </button>
        )
      })}
    </div>
  )
}
